import React, { useState } from "react";
import { Button, Menu, MenuItem, Checkbox, Box, styled } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

const MultiSelectFilter = ({
  FIELD_OPTIONS,
  selectedFields,
  handleFieldChange,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (fieldId) => {
    if (selectedFields.includes(fieldId)) {
      handleFieldChange(selectedFields.filter((id) => id !== fieldId));
    } else {
      handleFieldChange([...selectedFields, fieldId]);
    }
  };

  return (
    <Box>
      <StyledButton
        onClick={handleClick}
        variant="outlined"
        startIcon={<FilterListIcon />}
      >
        FILTERS
      </StyledButton>

      {/* Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ mt: 1 }}
      >
        {/* Field Options with Checkboxes */}
        {FIELD_OPTIONS.map((option) => (
          <MenuItem
            key={option.id}
            onClick={() => handleMenuItemClick(option.id)}
          >
            <Checkbox
              checked={selectedFields.includes(option.id)}
              size="small"
              sx={{ mr: 1 }}
            />
            <span>{option.label}</span>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default MultiSelectFilter;

// Styled Components

const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: "uppercase",
  fontWeight: 600,
  fontSize: "14px",
  letterSpacing: "0.5px",
  color: "#333",
  border: "none",
  borderRadius: "6px",
  "&:hover": {
    border: "none",
    backgroundColor: "#fafafa",
  },
}));
